export const config = {
    baseUrl: "",
}